import styles from '@/components/elements/BrandedBox/BrandedBox.module.scss'

const BrandedBox = ({ className, children }: any) => {
  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.titleDecoration} />
      {children}
    </div>
  )
}

export default BrandedBox
